module.exports = "/images/gotham-5.jpg";